export function rotating_text() {
  'use strict';

  // https://codepen.io/massimo-cassandro/pen/bGdWMER

  let wrapper_animazione = document.querySelector('.rotating-text'),
    array_testo_animazione = wrapper_animazione.querySelectorAll('span'),
    durata_animazione = 1.6; // secondi

  array_testo_animazione[0].insertAdjacentHTML('beforebegin', '<span></span>');
  let span_wrapper = wrapper_animazione.querySelector('span');

  array_testo_animazione.forEach((item, index) => {
    item.removeAttribute('hidden');
    item.style.cssText=`animation-duration:${array_testo_animazione.length * durata_animazione}s;` +
      `animation-delay:${index * durata_animazione}s`;
    span_wrapper.appendChild(item);
  });

  function calcolaDimensioni() {
    wrapper_animazione.querySelector('span').style.cssText = '';

    let higher_width = 0, higher_height = 0;
    wrapper_animazione.querySelectorAll('span > span').forEach(item => {
      higher_width = item.offsetWidth > higher_width? item.offsetWidth : higher_width;
      higher_height = item.offsetHeight > higher_height? item.offsetHeight : higher_height;
    });
    wrapper_animazione.querySelector('span').style.cssText = `min-width:${higher_width}px;`+
      `min-height:${higher_height}px`;

    // console.log(higher_width, higher_height);
  }

  calcolaDimensioni();

  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver( () => {
      calcolaDimensioni();
    });
    resizeObserver.observe(document.querySelector('.rotating-text'));
  }
  else {
    window.addEventListener('resize', calcolaDimensioni);

  }

}
